import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { StylishNewToggleButtonGroup } from 'components/DesignSystems/New/StylishNewToggleButtonGroup';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useFetchIncidentWorkspaceTeamStatus } from 'hooks/useFetchIncidentWorkspaceTeamStatus';
import { useActualIncidentId } from 'components/IAP/hooks/commonHooks';
import { RosterActionsProps, RosterViewMode } from './types';
import { useAppSelector } from 'slices/commonSelectors';
import IncidentNewSeatDialog from '../IncidentNewSeatDialog';
import AddResourceToRosterModal from './AddResourceToRosterModal';

const RosterActions = ({
  isDraft = false,
  viewMode,
  onViewModeChange,
}: RosterActionsProps) => {
  // Live-incident context only: this may fall back to the Redux selection.
  // Before reusing RosterActions for plans, pass the plan ID explicitly.
  const incidentId = useActualIncidentId();
  const { data: teamsStatus } = useFetchIncidentWorkspaceTeamStatus(incidentId);
  const permissions = useAppSelector(
    (state: any) => state.app.validateRBACPermissionForActionResult
  );
  const canChangeRoster = !!permissions?.['incident:changeRoster'];
  const [isNewSeatDialogOpen, setIsNewSeatDialogOpen] = useState(false);
  const [isAddResourceOpen, setIsAddResourceOpen] = useState(false);

  const onClickAddIncidentSeatButton = () => {
    if (teamsStatus === 'inprogress') {
      toast.success(
        'Creating team site is in progress. Please check back later.',
        {
          autoClose: 2000,
        }
      );
      return;
    }
    setIsNewSeatDialogOpen(true);
  };

  return (
    <>
      {/* Main Actions */}
      <div className="d-md-flex align-items-center mb-3">
        <h4 className="m-0">
          {isDraft ? '[DRAFT] - ' : ''}Incident Seat Roster
        </h4>
        {onViewModeChange && (
          <div className="ms-md-3 mt-md-0 mt-2">
            <StylishNewToggleButtonGroup
              size="sml"
              data={[
                { label: 'Org Chart View', value: 'orgchart' },
                { label: 'Table View', value: 'table' },
              ]}
              selected={viewMode ?? 'orgchart'}
              onChange={(value: string) =>
                onViewModeChange(value as RosterViewMode)
              }
            />
          </div>
        )}
        <div className="text-md-end ms-auto">
          {canChangeRoster && (
            <StylishNewButton
              className="button--secondary mt-md-0 w-md-auto ms-md-3 ms-0 ms-auto mt-2 w-100"
              onClick={() => setIsAddResourceOpen(true)}
            >
              Add Resource
            </StylishNewButton>
          )}
          <StylishNewButton
            className="button--secondary mt-md-0 w-md-auto ms-md-3 ms-0 mt-2 w-100"
            onClick={onClickAddIncidentSeatButton}
          >
            Manage {isDraft ? ' (Draft)' : ''} Custom Incident Seats
          </StylishNewButton>
        </div>
        {/* ) */}
      </div>

      {isNewSeatDialogOpen && (
        <>
          <IncidentNewSeatDialog
            show={true}
            onClose={() => setIsNewSeatDialogOpen(false)}
          />
        </>
      )}
      {isAddResourceOpen && (
        <AddResourceToRosterModal
          show={true}
          onClose={() => setIsAddResourceOpen(false)}
        />
      )}
    </>
  );
};

export default RosterActions;
